import { render, staticRenderFns } from "./PureModeBook.vue?vue&type=template&id=0ff059bc&scoped=true&"
import script from "@/scripts/PureMode/PureModeBook/index.js?vue&type=script&lang=js&"
export * from "@/scripts/PureMode/PureModeBook/index.js?vue&type=script&lang=js&"
import style0 from "./PureModeBook.vue?vue&type=style&index=0&id=0ff059bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff059bc",
  null
  
)

export default component.exports